export default __webpack_public_path__ + "static/footer-bg-shape-1-498fe24943e3bf4948e73c3d7c0cefc5.png";